import { schema } from "normalizr";

const EmployeeLeaveBalanceSchema = new schema.Entity("employeeLeaveBalances");
const EmployeeLeaveBalanceArraySchema = new schema.Array(EmployeeLeaveBalanceSchema);

export { 
  EmployeeLeaveBalanceSchema, 
  EmployeeLeaveBalanceArraySchema
};